// hreflang /coaches — как у остальных страниц: три языка и x-default на
// азербайджанскую версию (27.10.2026; русская — в корне).
const SITE = "https://yolutap.com";

export const COACHES_ALTERNATES = [
  { rel: "alternate", hrefLang: "ru", href: `${SITE}/coaches` },
  { rel: "alternate", hrefLang: "az", href: `${SITE}/az/coaches` },
  { rel: "alternate", hrefLang: "en", href: `${SITE}/en/coaches` },
  { rel: "alternate", hrefLang: "x-default", href: `${SITE}/az/coaches` },
];
